// extracted by mini-css-extract-plugin
export default {"f":"b1f37ba7ee","main":"_41dc955b60","btn":"_81097c6e69","w":"e227b4f37a","h":"_74144c8c18","lh25":"_9fbb42d261","wb":"_8ab2a6cce8","b":"_4c7ddef4d0","bx":"ea39f705e4"};